<template>
  <q-td
    v-if="!mobile"
    key="domain"
    :props="props"
    class="cmp-domain-title ws-text-primary"
  >
    <div class="wrapper">
      <ws-badge
        v-if="percentageDiscount && domain.availableForPurchase"
        tertiary
        class="discount-badge"
      >
        <small><strong>{{ percentageDiscount }}</strong></small>
      </ws-badge>
      <span class="domain-name q-mr-md">{{ domain.name | rmTld(domain.tld)
      }}<span class="tld text-bold">.{{ domain.tld }} </span></span>
      <caption
        v-if="showOccupied"
        class="text-occupied text-uppercase text-right q-mr-md"
      >
        {{
          $t('domain_checker.occupied.short_status')
        }}
      </caption>
      <premium-badge
        v-else-if="domain.premium"
        :class="{ dark: inCart }"
        class="q-mr-md"
      />
    </div>
  </q-td>
  <!-- MOBILE VIEW -->
  <div v-else class="cmp-domain-title">
    <premium-badge v-if="domain.premium" :class="{ dark: inCart }" />

    <div
      key="domain"
      :props="props"
      class="grid-item-domain ws-text-primary q-mb-xs"
    >
      <span class="domain-name">{{ domain.name | rmTld(domain.tld)
      }}<span class="tld text-bold">.{{ domain.tld }} </span></span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { QTd } from 'quasar';

import WsBadge from '@WS_Components/WsBadge.vue';
import { rmTld } from '@/utilities/filters';
import type { Domain, Price } from '@/components/domain-checker/dc.types';
import PremiumBadge from '@/components/domain-checker/PremiumBadge.vue';

@Component({
  components: {
    PremiumBadge,
    QTd,
    WsBadge,
  },

  filters: { rmTld },
})
export default class DomainTitle extends Vue {
  @Prop({ default: () => ({}) }) props!: any;
  @Prop(Boolean) readonly inCart!: boolean;

  get domain(): Domain | undefined {
    return this.props.row?.domain;
  }

  get percentageDiscount(): string | null {
    const domainPrice: Price | null = this.domain!.price || null;

    if (!domainPrice || !this.domain!.availableForPurchase) {
      return null;
    }

    const { marketingPrice, actualPrice } = domainPrice;

    if (marketingPrice && actualPrice && actualPrice < marketingPrice) {
      const discount = ((marketingPrice - actualPrice) / marketingPrice) * 100;
      return discount && discount > 0 ? '-' + Math.round(discount) + '%' : null;
    }

    return null;
  }

  get showOccupied(): boolean {
    return (
      !this.domain?.availableForPurchase && !this.domain?.error && !this.inCart
    );
  }
}
</script>

<style lang="scss" scoped>
.cmp-domain-title {
  position: relative;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .discount-badge {
    position: absolute;
    font-family: $ws-font-family-secondary;
    font-weight: bold;
    width: 42px;
    height: 42px;
    left: -21px;

    span small {
      color: $ws-white;
    }
    @media (max-width: 1024px) {
      display: none;
    }
  }

  .domain-name {
    overflow-wrap: break-word;
    min-width: 0;
  }
}
</style>
